var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27 9.00063L13 23L6 16.0006","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Check;

Check.default = Check;
